import {Swiper} from 'swiper'
import { ScrollTrigger } from 'gsap/ScrollTrigger'


// Filter buttons responsive swiper
let filterButtonsSlider = $('.js-resp-cats-swiper')
if (filterButtonsSlider.length){

  filterButtonsSlider.each((i, el)=> {

    if ($(window).innerWidth() < 1200) {

      let swiper = new Swiper(el, {
        //modules: FreeMode,
        slidesPerView: 'auto',
        //freeMode: true,
      });

    }

  })
}




$(document).ready(function() {

  $('.js-play-video').click(function (){
    let video = $(this).parent().find('video')
    loadElementLazyImage(video)
    $(this).fadeOut()
  })


  // Add wrapper to all tables
  $('table').wrap('<div class="table-wrapper js-scroll-table-when-in-screen"></div')


  // animate table scroll when in screen
  document.querySelectorAll('.js-scroll-table-when-in-screen').forEach(function (el) {
    if ($(el).find('table').width() > window.innerWidth) {
      ScrollTrigger.create({
        trigger: el,
        start: "top bottom", // el top, screen bottom
        once: true,
        onEnter: () => animateTableScroll(el)
      });
    }
  })



})


export function animateTableScroll(el){
  if ($(el).find('table').width() > window.innerWidth) {
    $(el).find('table').delay(400).animate({ left: '-80px' }, 600,
      function () {
        $(this).animate({ left: 0 }, 600)
      })
  }
}


